import { Component } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { LoginService } from '../../../../shared/pages/login/login.service';

@Component({
    selector: 'pcode-forgot-password-dialog',
    templateUrl: './forgot-password-dialog.component.html',
    styleUrls: ['./forgot-password-dialog.component.scss'],
    standalone: false
})
export class ForgotPasswordDialogComponent
{
	_form: UntypedFormGroup = this.fb.group(
		{
			email: [null, [Validators.required, Validators.email]]
		}
	);
	get email() { return this._form.get('email'); }

	// constructor
	constructor
		(
			private dialogRef: MatDialogRef<ForgotPasswordDialogComponent>,
			private fb: UntypedFormBuilder,
			private loginService: LoginService
		)
	{
	}

	// forgot password confirm
	forgotPasswordConfirm()
	{
		this._form.markAllAsTouched();

		if (this._form.valid)
		{
			this.loginService.forgotPassword(this._form.get('email').value).subscribe(
				() =>
				{
					this.dialogRef.close({ success: true });
				},
				error =>
				{
					this.dialogRef.close({ success: false, error: error });
				}
			)
		}
	}

	// close dialog
	closeDialog()
	{
		this.dialogRef.close({ created: false });
	}
}
